import Handlebars from '@sparta.global.vendors/handlebars';

/* eslint-disable consistent-return */

/**
 * @const STRINGS
 * @description constant for storing message strings
 */
var STRINGS = {
  NO_badge_JCR_ERROR: 'No badge or indicator JCR objects provided to helper-badging.'
};

/**
 * Default variables for the utility
 */
var DEFAULTS = new function defaultsSettingsConstructor() {
  // Class names and attributes
  this.preface = 'spa';
  this.component = 'badge';
  this.nameSpace = "".concat(this.preface, "-").concat(this.component);
  this.numeric = "".concat(this.nameSpace, " ").concat(this.nameSpace, "--numeric");
  this.dot = "".concat(this.nameSpace, " ").concat(this.nameSpace, "--dot");
}();

/**
 * @method helpers.badgingHelper
 * @param {object} jcr JSON object used to build the badgeHelper.
 * @param {object} context JSON options object used to build the badgeHelper.
 * @returns {Node} `Handlebars.SafeString` version of the dom element.
 * @description This pieces together all the HTML elements needed
 */
function badgingHelper(jcr, context) {
  if (!jcr) {
    throw new Error(STRINGS.NO_badge_JCR_ERROR);
  }
  // Create settings object from JCR information.
  // ----------------------------------- //
  var optionsData = jcr;
  var settings = new function SettingsContructor() {
    var _this = this;
    this.class = [];
    this.numberValue = '';

    // Base
    this.getID = optionsData.id ? optionsData.id : '';

    // output
    this.output = '';

    // Badge attributes.
    this.id = optionsData.id ? "id='".concat(this.getID.toLowerCase(), "'") : '';
    this.badgeType = '';
    if (optionsData.type && optionsData.type === 'numeric') {
      if (optionsData.content && optionsData.content > 0) {
        this.badgeType = 'numeric';
      } else {
        this.badgeType = 'dot';
      }
    }

    // Depending on the type, add the class
    if (this.badgeType === 'numeric') {
      this.class.push("".concat(DEFAULTS.numeric));
    } else {
      this.class.push("".concat(DEFAULTS.dot));
    }
    if (optionsData.options.position) {
      this.class.push("spa-badging-pos--".concat(optionsData.options.position));
    } else {
      this.class.push('spa-badging-pos--relative');
    }
    if (optionsData.classNames) {
      this.class.push("".concat(optionsData.classNames));
    }

    // Create a list of attributes for the cms wrapper
    var _optionsData$attribut = optionsData.attributes,
      attributes = _optionsData$attribut === void 0 ? {} : _optionsData$attribut;
    this.attributesString = '';
    Object.keys(attributes).forEach(function (key) {
      if (typeof attributes[key] === 'string' || typeof attributes[key] === 'boolean') {
        _this.attributesString += "".concat(key, "=\"").concat(attributes[key], "\"");
      } else {
        _this.attributesString += "".concat(key, "=\"").concat(Handlebars.Utils.escapeExpression(JSON.stringify(attributes[key])), "\"");
      }
    });

    // Check for value
    if (this.badgeType === 'numeric') {
      if (optionsData.content && optionsData.content > 0) {
        if (optionsData.content > 99) {
          this.numberValue = '99+';
        } else {
          this.numberValue = Math.trunc(optionsData.content);
        }
      }
    }

    // ADA text
    this.ariaLabel = optionsData.options.ariaLabel ? "<span class=\"ada-hidden\">".concat(optionsData.options.ariaLabel, "</span>") : '';

    // Create badge
    // ----------------------------------- //
    var classList = this.class.join(' ');
    this.output += "\n    <span ".concat(this.id, " \n      class=\"").concat(classList, "\" \n      ").concat(this.attributesString, "\n    >").concat(this.numberValue, "\n     ").concat(this.ariaLabel, "\n    </span>\n    ").trim();
  }();

  // return HTML to page
  // ----------------------------------- //
  return new Handlebars.SafeString(settings.output);
}
export { badgingHelper };